<template>
  <div>
    <!-- Hack to cover left sidebar -->
    <v-overlay class="sidebar-cover-overlay" v-if="modal.visible">
      <div class="sidebar-cover-clickable"></div>
    </v-overlay>

    <v-dialog v-model="modal.visible" persistent width="70%" max-width="1000">
      <v-stepper v-model="stepper" alt-labels class="stepper">
        <v-stepper-header></v-stepper-header>

        <v-stepper-items>
          <v-stepper-content :step="1">
            <v-card class="mx-auto">
              <v-card-text class="pa-0">
                <NotificationsStepCreateNew
                  @click-tripwires="
                    handleClickTripwiresBriefings(typeRiskRating)
                  "
                  @click-events="handleClickEvents"
                  @click-briefings="
                    handleClickTripwiresBriefings(typeElectionWatch)
                  "
                ></NotificationsStepCreateNew>
              </v-card-text>

              <v-card-actions>
                <NotificationsModalFooter
                  :is-update="false"
                  :loading="loading"
                  :hide-nav-buttons="true"
                  @click-cancel="handleClickCancel"
                ></NotificationsModalFooter>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content :step="2">
            <v-card class="mx-auto">
              <v-card-text class="pa-0">
                <NotificationsStepTripwires
                  v-if="isTripwire"
                  :notification="notification"
                  :read-only="modal.readOnly"
                ></NotificationsStepTripwires>

                <NotificationsStepBriefings
                  v-if="isBriefing"
                  :notification="notification"
                  :read-only="modal.readOnly"
                ></NotificationsStepBriefings>
              </v-card-text>

              <v-card-actions>
                <NotificationsModalFooter
                  :is-update="isUpdate"
                  :loading="loading"
                  :hide-nav-back="isUpdate"
                  :hide-nav-next="false"
                  :hide-nav-finish="true"
                  :validation="validation"
                  @click-step-next="handleClickStepNext"
                  @click-step-prev="handleClickStepPrev"
                  @click-delete="handleClickDelete"
                  @click-cancel="handleClickCancel"
                ></NotificationsModalFooter>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content :step="3">
            <v-card class="mx-auto">
              <v-card-text class="pa-0">
                <NotificationsStepComms
                  :read-only="modal.readOnly"
                ></NotificationsStepComms>
              </v-card-text>

              <v-card-actions>
                <NotificationsModalFooter
                  :is-update="isUpdate"
                  :loading="loading"
                  :hide-nav-back="isTypeSavedSearch"
                  :hide-nav-next="true"
                  :hide-nav-finish="false"
                  :validation="validation"
                  :save-failed="!saveSuccess"
                  @click-finish="handleClickFinish"
                  @click-step-prev="handleClickStepPrev"
                  @click-delete="handleClickDelete"
                  @click-cancel="handleClickCancel"
                ></NotificationsModalFooter>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-dialog>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashDebounce from "lodash/debounce";
import lodashCloneDeep from "lodash/cloneDeep";

import { mapGetters } from "vuex";
import { MODULE_PREFIX_NOTIFICATIONS } from "@/store";
import { GET_MODAL, GET_NOTIFICATION } from "@/store/actions.type";
import { saveNotification } from "@/services/notifications/notifications.service";
import {
  NOTIFICATION_DOC_TYPES,
  NOTIFICATION_FREQUENCY_IMMEDIATELY,
  NOTIFICATION_FREQUENCY_MONTHLY,
  NOTIFICATION_TRIPWIRE_TYPE_RISK_RATING,
  NOTIFICATION_TRIPWIRE_TYPE_EVACUATION,
  NOTIFICATION_TRIPWIRE_TYPE_HOTSPOT,
  NOTIFICATION_TRIPWIRE_TYPE_PULSE,
  NOTIFICATION_BRIEFING_TYPE_ELECTION_WATCH,
  NOTIFICATION_BRIEFING_TYPE_REGIONAL_OUTLOOK,
  NOTIFICATION_BRIEFING_TYPE_CYBER_WEEKLY,
  NOTIFICATION_BRIEFING_TYPE_CYBER_MONTHLY,
  NOTIFICATION_TYPE_SAVED_SEARCH,
} from "@/common/constants/notifications";
import {
  EVENT_ACTIONS,
  ALERTSV2_CATEGORIES,
} from "@/common/constants/analytics";

export default {
  name: "NotificationsModal",
  components: {
    NotificationsModalFooter: () =>
      import("@/components/notifications/NotificationsModalFooter"),
    NotificationsStepCreateNew: () =>
      import("@/components/notifications/NotificationsStepCreateNew"),
    NotificationsStepTripwires: () =>
      import("@/components/notifications/NotificationsStepTripwires"),
    NotificationsStepBriefings: () =>
      import("@/components/notifications/NotificationsStepBriefings"),
    NotificationsStepComms: () =>
      import("@/components/notifications/NotificationsStepComms"),
  },
  props: {},
  data() {
    return {
      stepCurrent: null,
      loading: false,
      refresh: null,
      docTypes: NOTIFICATION_DOC_TYPES.map((o) => o.value),
      saveSuccess: true,
      typeRiskRating: NOTIFICATION_TRIPWIRE_TYPE_RISK_RATING,
      typeElectionWatch: NOTIFICATION_BRIEFING_TYPE_ELECTION_WATCH,
    };
  },
  computed: {
    ...mapGetters({
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
      modal: MODULE_PREFIX_NOTIFICATIONS + "modal",
    }),
    stepper: {
      get() {
        if (this.stepCurrent === null) {
          return this.step;
        }
        return this.stepCurrent;
      },
      set(value) {
        this.stepCurrent = value;
      },
    },
    isUpdate() {
      return !!lodashGet(this.notification, "formatted.id");
    },
    isTripwire() {
      return (
        this.isTypeRisk ||
        this.isTypeEvacuation ||
        this.isTypeHotspot ||
        this.isTypePulse
      );
    },
    isBriefing() {
      return (
        this.isTypeElectionWatch ||
        this.isTypeRegionalOutlook ||
        this.isTypeCyberWeekly ||
        this.isTypeCyberMonthly
      );
    },
    isTypeSavedSearch() {
      return (
        lodashGet(this.notification, "formatted.docType") ===
        NOTIFICATION_TYPE_SAVED_SEARCH
      );
    },
    isTypeRisk() {
      return (
        lodashGet(this.notification, "formatted.docType") ===
        NOTIFICATION_TRIPWIRE_TYPE_RISK_RATING
      );
    },
    isTypeEvacuation() {
      return (
        lodashGet(this.notification, "formatted.docType") ===
        NOTIFICATION_TRIPWIRE_TYPE_EVACUATION
      );
    },
    isTypeHotspot() {
      return (
        lodashGet(this.notification, "formatted.docType") ===
        NOTIFICATION_TRIPWIRE_TYPE_HOTSPOT
      );
    },
    isTypePulse() {
      return (
        lodashGet(this.notification, "formatted.docType") ===
        NOTIFICATION_TRIPWIRE_TYPE_PULSE
      );
    },
    isTypeElectionWatch() {
      return (
        lodashGet(this.notification, "formatted.docType") ===
        NOTIFICATION_BRIEFING_TYPE_ELECTION_WATCH
      );
    },
    isTypeRegionalOutlook() {
      return (
        lodashGet(this.notification, "formatted.docType") ===
        NOTIFICATION_BRIEFING_TYPE_REGIONAL_OUTLOOK
      );
    },
    isTypeCyberWeekly() {
      return (
        lodashGet(this.notification, "formatted.docType") ===
        NOTIFICATION_BRIEFING_TYPE_CYBER_WEEKLY
      );
    },
    isTypeCyberMonthly() {
      return (
        lodashGet(this.notification, "formatted.docType") ===
        NOTIFICATION_BRIEFING_TYPE_CYBER_MONTHLY
      );
    },
    isValidatedName() {
      return !!lodashGet(this.notification, "formatted.name");
    },
    isValidatedLocations() {
      return !!(
        lodashGet(
          this.notification,
          "formatted.params.locations.regions.length"
        ) ||
        lodashGet(
          this.notification,
          "formatted.params.locations.countries.length"
        ) ||
        lodashGet(
          this.notification,
          "formatted.params.locations.cities.length"
        ) ||
        lodashGet(
          this.notification,
          "formatted.params.locations.counties.length"
        )
      );
    },
    isValidatedRisk() {
      return (
        this.isTypeRisk &&
        !!lodashGet(this.notification, "formatted.params.riskTypes.length")
      );
    },
    isValidatedEvacuation() {
      return this.isTypeEvacuation;
    },
    isValidatedHotspot() {
      return (
        this.isTypeHotspot &&
        !!lodashGet(this.notification, "formatted.params.hotspotTypes.length")
      );
    },
    isValidatedPulseTrigger() {
      return (
        this.isTypePulse &&
        !!lodashGet(this.notification, "formatted.params.pulseTrigger")
      );
    },
    isValidatedPulseScoreDrop() {
      return (
        this.isTypePulse &&
        (lodashGet(this.notification, "formatted.params.pulseTrigger") !==
          "score-drop" ||
          (lodashGet(this.notification, "formatted.params.pulseTrigger") ===
            "score-drop" &&
            lodashGet(this.notification, "formatted.params.pulseScoreDrop")))
      );
    },
    isValidatedPulse() {
      return (
        this.isTypePulse &&
        this.isValidatedPulseTrigger &&
        this.isValidatedPulseScoreDrop
      );
    },
    isValidatedFrequency() {
      return !!lodashGet(this.notification, "formatted.frequency");
    },
    isValidatedDelivery() {
      return !!lodashGet(this.notification, "formatted.delivery.length");
    },
    isValidatedTargets() {
      return (
        !!lodashGet(this.notification, "formatted.delivery.length") &&
        (!this.notification.formatted.delivery.includes("target") ||
          (this.notification.formatted.delivery.includes("target") &&
            !!lodashGet(this.notification, "formatted.targets.length")))
      );
    },
    isValidatedShare() {
      return (
        !lodashGet(this.notification, "formatted.sharedList.length") ||
        (!!lodashGet(this.notification, "formatted.sharedList.length") &&
          !!lodashGet(this.notification, "formatted.delivery.length") &&
          (this.notification.formatted.delivery.includes("email") ||
            this.notification.formatted.delivery.includes("push")))
      );
    },
    validation() {
      const arr = [];
      if (!this.isValidatedName) {
        arr.push("A Notification Name must be entered");
      }
      if (this.stepper === 2) {
        if (this.isTripwire) {
          if (this.isTypeRisk) {
            if (!this.isValidatedLocations) {
              arr.push("At least one Region or Country must be selected");
            }
            if (!this.isValidatedRisk) {
              arr.push("A least one Risk Type must be selected");
            }
          }
          if (this.isTypeEvacuation) {
            if (!this.isValidatedLocations) {
              arr.push("At least one Region or Country must be selected");
            }
          }
          if (this.isTypeHotspot) {
            if (!this.isValidatedLocations) {
              arr.push("At least one Region, Country or City must be selected");
            }
            if (!this.isValidatedHotspot) {
              arr.push("A least one Hotspot Type must be selected");
            }
          }
          if (this.isTypePulse) {
            if (!this.isValidatedLocations) {
              arr.push(
                "At least one Region, Country, City or US County must be selected"
              );
            }
            if (!this.isValidatedPulse) {
              if (!this.isValidatedPulseTrigger) {
                arr.push("A Pulse Change Trigger must be selected");
              }
              if (!this.isValidatedPulseScoreDrop) {
                arr.push(
                  "A Specified Score Drop value between 0 and 100 must be set"
                );
              }
            }
          }
        } else if (this.isBriefing) {
          if (this.isTypeElectionWatch) {
            if (!this.isValidatedLocations) {
              arr.push("At least one Region or Country must be selected");
            }
          }
          if (this.isTypeRegionalOutlook) {
            if (!this.isValidatedLocations) {
              arr.push("At least one Region must be selected");
            }
          }
        }
      }
      if (this.stepper === 3) {
        if (!this.isValidatedFrequency) {
          arr.push("A Delivery Frequency must be selected");
        }
        if (!this.isValidatedDelivery) {
          arr.push("A Delivery Channel must be selected");
        }
        if (!this.isValidatedTargets) {
          arr.push(
            "A Target must be selected when the Targets Delivery Channel is selected"
          );
        }
        if (!this.isValidatedShare) {
          arr.push(
            "Email or push must be selected when sharing with colleagues"
          );
        }
      }
      return arr;
    },
  },
  methods: {
    closeModal() {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        null
      );
      const modal = lodashCloneDeep(this.modal);
      modal.visible = false;
      modal.type = null;
      this.$store.dispatch(MODULE_PREFIX_NOTIFICATIONS + GET_MODAL, modal);
    },
    handleClickStepNext() {
      this.stepper++;
    },
    handleClickStepPrev() {
      this.stepper--;
    },
    handleClickCancel() {
      this.closeModal();
    },
    async handleClickFinish() {
      this.loading = true;
      this.saveSuccess = await saveNotification(this.notification);
      if (!this.saveSuccess) {
        this.loading = false;
      } else {
        lodashDebounce(() => {
          this.captureSaveTracking();
          this.loading = false;
          this.closeModal();
        }, 1000)();
      }
    },
    async handleClickDelete() {
      const modal = lodashCloneDeep(this.modal);
      modal.delete = true;
      this.$store.dispatch(MODULE_PREFIX_NOTIFICATIONS + GET_MODAL, modal);
    },
    async setNotificationByType(type) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.docType = type;
      notification.formatted.frequency = NOTIFICATION_FREQUENCY_IMMEDIATELY;
      if (type === NOTIFICATION_BRIEFING_TYPE_ELECTION_WATCH) {
        notification.formatted.frequency = NOTIFICATION_FREQUENCY_MONTHLY;
      }
      await this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
    },
    async handleClickTripwiresBriefings(type) {
      await this.setNotificationByType(type);
      const modal = lodashCloneDeep(this.modal);
      modal.type = type;
      this.$store.dispatch(MODULE_PREFIX_NOTIFICATIONS + GET_MODAL, modal);
      this.stepper = 2;
    },
    handleClickEvents() {
      this.closeModal();
    },
    resetModal() {
      this.stepper = 1;
      this.message = {};
      this.loading = false;
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        null
      );
    },
    captureSaveTracking() {
      if (lodashGet(this.notification, "formatted.id")) {
        this.handlePageTrackerEvent(
          ALERTSV2_CATEGORIES.alertsv2,
          EVENT_ACTIONS.selected,
          !!this.notification.formatted.id ? "Update" : "New"
        );
      }
      if (lodashGet(this.notification, "formatted.frequency")) {
        this.handlePageTrackerEvent(
          ALERTSV2_CATEGORIES.alertsv2_frequency,
          EVENT_ACTIONS.selected,
          this.notification.formatted.frequency
        );
      }
      if (lodashGet(this.notification, "formatted.expiration")) {
        this.handlePageTrackerEvent(
          ALERTSV2_CATEGORIES.alertsv2_expiration,
          EVENT_ACTIONS.selected,
          this.notification.formatted.expiration
        );
      }
      if (lodashGet(this.notification, "formatted.sharedList.length")) {
        this.handlePageTrackerEvent(
          ALERTSV2_CATEGORIES.alertsv2_sharing,
          EVENT_ACTIONS.selected,
          true
        );
      }
      if (lodashGet(this.notification, "formatted.delivery")) {
        this.notification.formatted.delivery.forEach((delivery) => {
          this.handlePageTrackerEvent(
            ALERTSV2_CATEGORIES.alertsv2_delivery,
            EVENT_ACTIONS.selected,
            delivery
          );
        });
      }
      if (lodashGet(this.notification, "formatted.docType")) {
        this.handlePageTrackerEvent(
          ALERTSV2_CATEGORIES.alertsv2,
          EVENT_ACTIONS.selected,
          this.notification.formatted.docType
        );
      }
      if (lodashGet(this.notification, "formatted.params.hotspotTypes")) {
        this.notification.formatted.params.hotspotTypes.forEach((type) => {
          this.handlePageTrackerEvent(
            ALERTSV2_CATEGORIES.alertsv2_hotspot,
            EVENT_ACTIONS.selected,
            type
          );
        });
      }
      if (lodashGet(this.notification, "formatted.params.riskTypes")) {
        this.notification.formatted.params.riskTypes.forEach((type) => {
          this.handlePageTrackerEvent(
            ALERTSV2_CATEGORIES.alertsv2_risk_rating,
            EVENT_ACTIONS.selected,
            type
          );
        });
      }
      if (lodashGet(this.notification, "formatted.params.pulseTrigger")) {
        this.handlePageTrackerEvent(
          ALERTSV2_CATEGORIES.alertsv2_pulse,
          EVENT_ACTIONS.selected,
          this.notification.formatted.params.pulseTrigger
        );
      }
      if (lodashGet(this.notification, "formatted.params.pulseScoreDrop")) {
        this.handlePageTrackerEvent(
          ALERTSV2_CATEGORIES.alertsv2_pulse,
          EVENT_ACTIONS.selected,
          this.notification.formatted.params.pulseScoreDrop
        );
      }
    },
  },
  watch: {
    modal: {
      handler() {
        this.loading = false;
        if (lodashGet(this.modal, "type")) {
          if (
            this.modal.type !== NOTIFICATION_TYPE_SAVED_SEARCH &&
            this.docTypes.includes(this.modal.type)
          ) {
            this.stepper = 2;
          } else if (this.modal.type === NOTIFICATION_TYPE_SAVED_SEARCH) {
            this.stepper = 3;
          }
        } else {
          this.stepper = 1;
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.resetModal();
    this.closeModal();
  },
};
</script>

<style>
.stepper .v-stepper__label {
  text-align: center !important;
}
</style>

<style scoped>
.sidebar-cover-overlay.v-overlay {
  left: 0px !important;
}
.sidebar-cover-clickable {
  width: 100vw;
  height: 100vh;
}
</style>
